export enum StreamState {
  LoadingPlayer,
  LoadingCameras,
  LoadingStreamUrl,
  Streaming,
  Error,
  Idle
}

export class Camera {

  streamName: string;
  live: boolean;
  userId: number;

  // 0: mview
  // 1: kinesis
  // 2: wowza
  streamingPlatformType: number;

  // NotRegistered = 1,
  // Active = 2,
  // Cancelled = 3,
  // Errored = 4
  status: number;

  deviceGroupUserId: number;

}

export class Device {

  icvMarkerPath = "M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759 c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713 v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336 h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805z";
  bwcMarkerPath = "M82.3, 6L21.7, 6C13.1, 6, 6.2, 13, 6.2, 21.5L6.2, 122.8C6.2, 131.4, 13.2, 138.3, 21.7, 138.3L82.3, 138.3C90.9, 138.3, 97.8, 131.3, 97.8, 122.8L97.8, 21.4C97.8, 13, 90.9, 6, 82.3, 6z M14.8, 37.6C14.8, 30.8 20.2, 25.2 26.9, 25.2 33.6, 25.2 39, 30.7 39, 37.6 39, 44.4 33.6, 50 26.9, 50 20.2, 50 14.8, 44.4 14.8, 37.6z M51.7, 100.1C36.5, 100.1 24.2, 87.8 24.2, 72.6 24.2, 57.4 36.5, 45.1 51.7, 45.1 66.9, 45.1 79.2, 57.4 79.2, 72.6 79.2, 87.8 66.9, 100.1 51.7, 100.1z";

  gpsStaleTimeout: number;
  gpsLostTimeout: number;
  cameraOfflineThreshold: number;

  constructor(gpsStaleTimeout: number, gpsLostTimeout: number,  cameraOfflineThreshold: number) {
    this.gpsStaleTimeout = gpsStaleTimeout;
    this.cameraOfflineThreshold = cameraOfflineThreshold;
    this.gpsLostTimeout = gpsLostTimeout;
  }


  id: number;
  name: string;
  deviceGroupUserId: number;

  gpsLatitude: number;
  gpsLongitude: number;
  gpsHeading: number;
  gpsLocationTime: Date;
  // 0 = Old
  // 1 = Fresh
  // 2 = Unknown
  // NULL = Unknown
  gpsAgeOfData: number; 

  lastSeenOnline: Date;

  // 0 = ICV
  // 1 = Mobile Broadcast
  // 2 = Windows Broadcast
  // 3 = BWC
  // 4 = Drone
  sourceType: number;

  // 0 = Offline
  // 1 = Online
  status: ConnectionState;

  companyId: number;
  companyName: string;

  triggerTime: Date;
  triggerSource: string;

  isStreaming: boolean;
  isRecording: boolean;

  uiState: UiState = new UiState();

  get iconPath(): string {

    if (this.sourceType == 3) {
      return this.bwcMarkerPath;
    }

    return this.icvMarkerPath;

  }

  // 0 = Old / Stale
  // 1 = Fresh
  // 2 = Unknown / GPS Lost
  // This property is calculated client side 
  get gpsState(): GpsState {

    let isOld = this.gpsLocationTime && this.gpsLocationTime.getTime() + (this.gpsLostTimeout * 1000) < Date.now();
    let isLost = !this.gpsAgeOfData || this.gpsAgeOfData == 0 || !this.gpsLatitude || !this.gpsLongitude || !this.gpsLocationTime || isOld;
    if (isLost) {
      return GpsState.Old;
    }

    let isFresh = this.gpsLocationTime && this.gpsLocationTime.getTime() + (this.gpsStaleTimeout * 1000) > Date.now();

    if (isFresh) {
      return GpsState.Fresh;
    }
    
    return GpsState.Unknown;

  }

  get connectionState(): ConnectionState {

    let isOnline = this.lastSeenOnline && new Date(this.lastSeenOnline).getTime() + (this.cameraOfflineThreshold * 1000) > Date.now();

    if (isOnline) {
      return ConnectionState.Online;
    }

    return ConnectionState.Offline;

  }

  // Map Marker properties
  position: any;
  options: any;
  icon: any;
  title: any;

  public Equals(device: Device): boolean {

    return device.id == this.id &&
      device.status == this.status &&
      device.gpsLatitude == this.gpsLatitude &&
      device.gpsLongitude == this.gpsLongitude &&
      device.gpsHeading == this.gpsHeading &&
      device.gpsLocationTime.getTime() == this.gpsLocationTime.getTime() &&
      device.lastSeenOnline.getTime() == this.lastSeenOnline.getTime() &&
      device.gpsAgeOfData == this.gpsAgeOfData &&
      device.isStreaming == this.isStreaming &&
      device.isRecording == this.isRecording;
  }
}

export enum ConnectionState {
  Offline = 0,
  Online = 1
}

export enum GpsState {
  Old = 0,
  Fresh = 1,
  Unknown = 2
}

export class UiState {
  selected: boolean = false;
  highlighted: boolean = false;
  visible: boolean = true;

}
